package snow.platform.web.audio.howlerjs;

import snow.audio.Audio;
import snow.types.Types;

class SoundStream extends snow.platform.web.audio.SoundStream {

} //SoundStream
